import React from "react";
import { QueryRenderer } from "@cubejs-client/react";
import { Spin } from "antd";
import { AutoComplete } from "antd";
import cubejsApi from "../../cubejsApiBQ";

const cascaderTigo = ({ resultSet, props }) => {
    var dataSource = [];
    resultSet.loadResponse.data.map((result, index) => {
        var start = result["RESUMENTigo.mesCorte"].slice(0, 4);
        var end = result["RESUMENTigo.mesCorte"].slice(-2);
        var concat = start.concat("-", end);
        return (dataSource[index] = concat);
    });

    if (props.fecha === "") {
        let fecha = dataSource[dataSource.length - 1];
        let inicio = fecha.slice(0, 4);
        let final = fecha.slice(-2);
        let concat = inicio.concat(final);
        props.setFecha(concat);
    }

    const _onSelect = (value) => {
        let fecha = value;
        let inicio = fecha.slice(0, 4);
        let final = fecha.slice(-2);
        let concat = inicio.concat(final);
        props.setFecha(concat);
    };
    return (
        <AutoComplete
            style={{
                width: "100%",
                marginBottom: "25px",
            }}
            size="large"
            dataSource={dataSource}
            defaultValue={dataSource[dataSource.length - 1]}
            onSelect={(value, option) => _onSelect(value, option)}
        />
    );
};

const renderChart = (Component, props) => ({ resultSet, error }) =>
    (resultSet && <Component resultSet={resultSet} props={props} />) || (
        <Spin />
    );

const CascaderTigo = (props) => (
    <QueryRenderer
        query={{
            dimensions: ["RESUMENTigo.mesCorte"],
            timeDimensions: [],
            segments: [],
            measures: [],
            filters: [],
            order: {
                // "BaseResumenColocacion.fechaCorte": "asc"
            },
            renewQuery: true,
        }}
        cubejsApi={cubejsApi}
        render={renderChart(cascaderTigo, props)}
    />
);

export default CascaderTigo;
